<template>
  <div>
    <AppHeader />
    <router-view :key="key" />
    <Footer />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeaderOther.vue";
export default {
  name: "indexOther",
  components: { AppHeader },
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
/*footer*/
::v-deep .footer {
  // margin-bottom: 50rem;
  color: #fff;
  padding-top: 50rem;
  .clear {
    clear: both;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  ul {
    list-style: none;
  }
  img {
    border: 0;
  }
  a {
    text-decoration: none;
  }
  .mt20 {
    margin-top: 20rem !important;
  }
  .mb20 {
    margin-bottom: 20rem !important;
  }
  .mt45 {
    margin-top: 45rem;
  }
  .pt30 {
    padding-top: 30rem;
  }

  .home {
    // width: 1200rem;
    margin: 0 261rem;
  }
  .menu {
    color: #525e6d;
  }
  .menu a {
    padding: 0 10rem;
    color: #fff;
  }
  .right_f {
    text-align: center;
    width: 122rem;
  }
  .right_f img {
    width: 110rem;
    margin: 0 auto;
  }
  .right_f p {
    font-size: 12rem;
    color: #bdd0de;
    padding-top: 10rem;
  }
  .bottom-f {
    color: #bdd0de;
    background: #20242c;
    height: 45rem;
    line-height: 45rem;
    margin-top: 30rem;
  }
  .bottom-f .bq li {
    float: left;
  }
  .bottom-f .bq li span {
    color: #bdd0de;
    font-size: 13rem;
  }
  .bottom-f img {
    padding-left: 7rem;
    padding-top: 12rem;
    padding-right: 30rem;
  }
  .tel {
    width: 400rem;
    padding-top: 50rem;
  }
  .tel img {
    padding-right: 15rem;
  }
  .tel .hm p,
  .hm span,
  .footer_bottom {
    color: #bdd0de;
  }
  .tel .hm p {
    font-size: 22rem;
  }
  .footer_bottom {
    padding-top: 20rem;
    font-size: 14rem;
  }
  .dtgif {
    position: relative;
    left: -50rem;
    display: none;
  }
}
</style>
